import React, { useCallback } from "react";
import { useRouter } from "next/router";

import type {
  BriefingsPageData,
  BriefingType,
} from "content-ui/briefings/types";
import { handleBriefingCardTracking } from "content-ui/briefings/lib";

import { useMixpanelTracking } from "lib/hooks/useMixpanelTracking";
import { useUserData } from "lib/store/user";

import FeaturedHorizontalItem from "components/featuredHorizontalItem/featuredHorizontalItem";

type FeaturedBriefingProps = {
  pageData: BriefingsPageData;
  briefings: { list: BriefingType[]; count: number };
};

const FeaturedBriefing = ({ pageData, briefings }: FeaturedBriefingProps) => {
  const router = useRouter();
  const { track } = useMixpanelTracking();
  const { readerSubscriptionLevel } = useUserData();
  const featured = pageData.featuredBriefing
    ? pageData.featuredBriefing
    : briefings.list[0];
  const {
    featuredLabel,
    featuredHeading,
    featuredDescription,
    featuredButtonLabel,
  } = pageData;

  const handleBriefingClick = useCallback(async () => {
    await handleBriefingCardTracking({
      briefing: featured,
      path: router.asPath,
      readerSubscriptionLevel,
      track,
      component: "FeaturedBriefing",
    });
  }, [featured, router.asPath, readerSubscriptionLevel, track]);

  if (!featured) return null;

  return (
    <FeaturedHorizontalItem
      image={featured.briefingImage}
      url={featured.url}
      featuredHeading={featuredHeading || featured.title}
      featuredLabel={`${featuredLabel || "Latest"} / ${featured.marketLabel}`}
      publishTimestamp={featured.publishTimestamp}
      title={featured.title}
      featuredDescription={featuredDescription || featured.subtitle}
      excerpt={featured.subtitle}
      featuredButtonLabel={featuredButtonLabel}
      leftLabel={featured.marketLabel}
      onFeaturedButtonClick={handleBriefingClick}
      onFeatureCardClick={handleBriefingClick}
    />
  );
};

export default FeaturedBriefing;
